import { queryOptions, type QueryClient } from '@tanstack/react-query';
import type { PortalMe } from '@dxl/shared';
import { api } from './api';

/**
 * Händlerportal unter /m/<kürzel>/portal: eigene Sitzung (Cookie dxl_hsid) und eigenes CSRF-Token,
 * unabhängig von einer gleichzeitigen Anmeldung im Backoffice.
 */
const tokens = new Map<string, string>();

export const portalPfad = (kuerzel: string, pfad: string) => `/api/portal/${kuerzel.toUpperCase()}${pfad}`;

export function portalApi<T>(kuerzel: string, pfad: string, optionen: Parameters<typeof api>[1] = {}): Promise<T> {
  const csrf = tokens.get(kuerzel.toUpperCase());
  return api<T>(portalPfad(kuerzel, pfad), { ...optionen, kopf: { ...optionen.kopf, ...(csrf ? { 'x-csrf-token': csrf } : {}) } });
}

export const portalMeAbfrage = (kuerzel: string) =>
  queryOptions({
    queryKey: ['portal-me', kuerzel.toUpperCase()],
    queryFn: async (): Promise<PortalMe | null> => {
      const me = await api<PortalMe | null>(portalPfad(kuerzel, '/me'));
      if (me) tokens.set(kuerzel.toUpperCase(), me.csrf);
      else tokens.delete(kuerzel.toUpperCase());
      return me;
    },
    staleTime: 60_000,
  });

export const portalMeNeuLaden = (qc: QueryClient, kuerzel: string) => qc.fetchQuery({ ...portalMeAbfrage(kuerzel), staleTime: 0 });

/** Nach dem Abmelden: Sitzung und alle Daten des Händlers aus dem Cache */
export function portalLeeren(qc: QueryClient, kuerzel: string) {
  tokens.delete(kuerzel.toUpperCase());
  qc.setQueryData(portalMeAbfrage(kuerzel).queryKey, null);
  qc.removeQueries({ predicate: (q) => q.queryKey[0] === 'portal' && q.queryKey[1] === kuerzel.toUpperCase() });
}
